var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidemenu4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_2239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1882 1.87109C26.1289 3.90696 23.6178 6.48627 19.993 6.48627C16.4171 6.48627 13.9185 3.98352 12.8398 1.95727C13.3474 3.58485 13.6281 6.9483 8.97223 9.93456L8.9584 9.93253V29.9346C8.9584 36.0291 13.8984 40.9691 19.9929 40.9691C26.0874 40.9691 31.0275 36.0291 31.0275 29.9346V9.93456C26.2874 6.89455 26.664 3.46352 27.1882 1.87109Z",
    fill: "#556080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9277 31.3432C30.7325 31.328 30.5367 31.3135 30.338 31.3135C26.1483 31.3135 22.7518 34.7101 22.7518 38.8997C22.7518 39.47 22.8201 40.0238 22.9394 40.5583C27.1608 39.3901 30.3608 35.7825 30.9277 31.3432Z",
    fill: "#374056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64809 31.3135C9.44879 31.3135 9.25363 31.3279 9.0584 31.3432C9.62527 35.7825 12.8253 39.3901 17.0467 40.5591C17.166 40.0239 17.2343 39.4701 17.2343 38.8998C17.2344 34.7101 13.8378 31.3135 9.64809 31.3135Z",
    fill: "#374056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6827 38.2104H19.3034C18.9227 38.2104 18.6137 37.9014 18.6137 37.5207C18.6137 37.14 18.9227 36.8311 19.3034 36.8311H20.6827C21.0634 36.8311 21.3724 37.14 21.3724 37.5207C21.3723 37.9014 21.0633 38.2104 20.6827 38.2104Z",
    fill: "#374056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 15.499C25.212 14.4997 24.4024 13.6865 23.4044 13.4575C21.5968 13.0437 19.9927 14.4051 19.9927 16.1417C19.9927 14.4051 18.3885 13.0437 16.5816 13.4575C15.583 13.6865 14.774 14.4996 14.5485 15.499C14.3182 16.519 14.6533 17.47 15.3002 18.1045C16.8905 19.6638 18.5134 21.1887 19.9044 22.9273L19.9927 23.0383L20.0816 22.9273C21.4727 21.1887 23.0955 19.6638 24.6851 18.1045C25.3328 17.4701 25.6679 16.519 25.4375 15.499Z",
    fill: "#F3D55B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993 6.48604C24.1827 6.48604 26.8896 3.03774 27.5792 0.96875C22.5943 2.80805 17.3557 2.80735 12.4067 0.96875C13.0854 3.04876 15.8033 6.48604 19.993 6.48604Z",
    fill: "#374056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9241 4.41699C37.9241 4.41699 40.4779 8.11287 35.8551 9.24459C35.8551 9.24459 33.7751 4.42801 37.9241 4.41699Z",
    fill: "#3B97D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9241 4.41704C35.8262 2.14672 27.5792 0.96875 27.5792 0.96875C27.5792 0.96875 24.6013 5.81221 31.0275 9.93433L35.8551 9.24464C35.8551 9.24464 33.7751 4.42806 37.9241 4.41704Z",
    fill: "#D0E8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07595 4.41699C2.07595 4.41699 -0.477892 8.11287 4.14494 9.24459C4.14494 9.24459 6.22495 4.42801 2.07595 4.41699Z",
    fill: "#3B97D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07594 4.41704C4.17384 2.14672 12.4208 0.96875 12.4208 0.96875C12.4208 0.96875 15.3988 5.81221 8.97253 9.93433L4.14494 9.24464C4.14494 9.24464 6.22494 4.42806 2.07594 4.41704Z",
    fill: "#D0E8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7171 24.4175C12.0978 24.4175 12.4068 24.1085 12.4068 23.7278C12.4068 23.3471 12.0978 23.0381 11.7171 23.0381H8.95847V24.4174H11.7171V24.4175Z",
    fill: "#374056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0964 27.1763C13.4771 27.1763 13.7861 26.8673 13.7861 26.4866C13.7861 26.1059 13.4771 25.7969 13.0964 25.7969H8.9584V27.1762H13.0964V27.1763Z",
    fill: "#374056"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_2239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.96875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidemenu4);
export default __webpack_public_path__ + "static/media/sidemenu-4.24e4785118000d0e9cf27790e441ecef.svg";
export { ForwardRef as ReactComponent };